import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'home',
		component: resolve => require(['../pages/home.vue'], resolve)
	}, {
		path: '/introduce',
		name: 'introduce',
		component: resolve => require(['../pages/introduce.vue'], resolve)
	}, {
		path: '/service/',
		name: 'service',
		component: resolve => require(['../pages/service.vue'], resolve)
	}, {
		path: '/news',
		name: 'news',
		component: resolve => require(['../pages/news.vue'], resolve)
	}, {
		path: '/contact',
		name: 'contact',
		component: resolve => require(['../pages/contact.vue'], resolve)
	}, {
		path: '/introduceleaders',
		name: 'introduceleaders',
		component: resolve => require(['../pages/introduceleaders.vue'], resolve)
	}, {
		path: '/newsdetail',
		name: 'newsdetail',
		component: resolve => require(['../pages/newsdetail.vue'], resolve)
	}]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js